module.exports = __webpack_public_path__ + "media/images/icon__search-749096a8296e0c46cbf3baa40eb9e7c2.png";